module.exports = __webpack_public_path__ + "static/media/cybertruck.bf79df3f.png";